import { IVersionedId, ServiceBase } from '@/services/ServiceBase';
import * as request from 'superagent';

const API_URL = `${process.env.VUE_APP_API_URL}/workers`;

export class WorkerService extends ServiceBase {
  public static async getWorker(): Promise<IWorker | null> {
    try {
      const result = await (this.authRequest(request
        .get(API_URL)))
        .timeout(5000);

      return result.body;
    } catch (err) {
      if (err.status === 404) {
        console.log('Worker not found.');
        return null;
      }

      throw err;
    }
  }

  public static async createWorker(req: ICreateWorkerRequest): Promise<IVersionedId> {
    try {
      const result = await (this.authRequest(request.post(API_URL)))
        .send(req)
        .timeout(5000);

      return result.body;
    } catch (err) {
      console.error('Error while creating worker!', err);
      throw err;
    }
  }
}

export interface IWorker {
  userId: number;
  email: string;
  firstName: string;
  lastName: string;
  signatureImage: string;
  userVersion: number;
  workerVersion: number;
}

export interface ICreateWorkerRequest {
  email: string;
  firstName: string;
  lastName: string;
  signatureImage: string;
}
